// TODO: all folder to be removed, when removing flag flag-ev-mentoring-multiple-mentor-programs

const getMentorProfile = ({ mentorProfiles, networkId, topicId }) =>
  mentorProfiles?.find((p) => {
    if (topicId) {
      return p.owner_type === 'Topics::Topic' && p.owner_id === topicId;
    }

    return p.owner_type === 'Network' && p.owner_id === networkId;
  });

const updateMentorProfiles = ({ mentorProfiles = [], profile }) => {
  const existingProfile = mentorProfiles.find((p) => p.id === profile.id);

  if (!existingProfile) {
    return [...mentorProfiles, profile];
  }

  const updatedProfiles = mentorProfiles.filter(
    (p) => p.id !== existingProfile.id,
  );

  return [...updatedProfiles, profile];
};

export { getMentorProfile, updateMentorProfiles };
